export default {"src":"/_next/static/media/daily_icon.dad0f923.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};